// 2_components/cart_widget.js
// Cart popup widget: positions it under the header cart button, mirrors the total
// price and continue button into the widget, and on mobile sends the cart button
// straight to the cart page.

let firstLoadOfCartWidget = true;
let cartWidgetSaveContinueButtonCopy;

export function init() {
	document.addEventListener("DOMContentLoaded", function () {
		const cartWidget = document.querySelector("#cart-widget");
		const cartNavigationButton = document.querySelector("#header .cart-count");
		const navigation = document.querySelector("#header #navigation");
		window.NAT.utils.positionOfFixedComponent(cartWidget, cartNavigationButton, cartNavigationButton, navigation, true);
	});

	document.addEventListener("ShoptetDOMCartContentLoaded", function () {
		saveContinueButton();
		insertTotalPriceToCartWidget();
	});

	//on Mobile Straight to cart page, on desktop show the cart widget
	addCartWidgetToCartMobileListener();
}

function saveContinueButton() {
	if (firstLoadOfCartWidget) {
		console.log("First load of cart widget, saving continue button.");
		const cartWidgetContinueButton = document.querySelector("#cart-widget .cart-widget-button");
		if (cartWidgetContinueButton) {
			cartWidgetSaveContinueButtonCopy = cartWidgetContinueButton.cloneNode(true);
			firstLoadOfCartWidget = false;
			return;
		}
	}

	if (!cartWidgetSaveContinueButtonCopy) return;
	if (!firstLoadOfCartWidget) {
		const cartWidget = document.querySelector("#cart-widget");
		cartWidget.appendChild(cartWidgetSaveContinueButtonCopy);
	}
}

function insertTotalPriceToCartWidget() {
	const header = document.querySelector("#header");
	if (!header) {
		return;
	}
	const totalPriceElement = header.querySelector(".cart-price");
	if (!totalPriceElement) {
		return;
	}
	const totalPrice = totalPriceElement.textContent.trim();
	if (!totalPrice) {
		return;
	}

	const cartWidgetButton = document.querySelector("#cart-widget .cart-widget-button");
	if (!cartWidgetButton) {
		return;
	}

	const popupWidgetInner = document.querySelector("#cart-widget .cart-widget-inner");
	if (popupWidgetInner) {
		popupWidgetInner.appendChild(cartWidgetButton);
	}

	const existingTotalPriceElement = cartWidgetButton.querySelector(".cart-total-price-wrapper");
	if (existingTotalPriceElement) {
		existingTotalPriceElement.remove();
	}

	const totalPriceInCartWidgetElement = document.createElement("div");
	totalPriceInCartWidgetElement.className = "cart-total-price-wrapper";

	const totalPriceStrong = document.createElement("strong");
	totalPriceStrong.className = "cart-total-price";
	totalPriceStrong.innerHTML = totalPrice;

	const totalPriceLabel = document.createElement("span");

	totalPriceLabel.innerHTML = window.NAT.translations("cartTotalLabel");

	totalPriceInCartWidgetElement.appendChild(totalPriceLabel);
	totalPriceInCartWidgetElement.appendChild(totalPriceStrong);
	cartWidgetButton.appendChild(totalPriceInCartWidgetElement);
}

function addCartWidgetToCartMobileListener() {
	const header = document.querySelector("#header");
	if (!header) {
		console.warn("Header not found.");
		return;
	}
	const cartButton = header.querySelector(".navigation-buttons");
	if (!cartButton) {
		console.warn("Cart button not found.");
		return;
	}
	const cartHrefA = cartButton.querySelector("a");
	if (!cartHrefA) {
		console.warn("Cart button href not found.");
		return;
	}
	const cartHref = cartHrefA.getAttribute("href");
	if (!cartHref) {
		console.warn("Cart button href is empty.");
		return;
	}

	const appliedEvents = ["click", "touchstart"];

	appliedEvents.forEach(function (eventType) {
		cartButton.addEventListener(eventType, function (event) {
			if (!window.NAT.media.isDesktop) {
				event.preventDefault();
				console.log("Cart button clicked on mobile, redirecting to cart page.");
				window.location.href = cartHref;
			} else {
				console.log("Cart button clicked on desktop, no action needed.");
			}
		});
	});
}
